var NAME = "name";
var EMAIL = "email";
var PICTURE_URL = "picture";
var FIRST_NAME = "first_name";
var LAST_NAME = "last_name";
var GENDER = "gender";
var BIRTHDAY = "birthday";
var MIN_AGE = "min_age";
var MAX_AGE = "max_age";

var StitchUserProfileImpl = function () {
  function StitchUserProfileImpl(userType, data, identities) {
    if (data === void 0) {
      data = {};
    }

    if (identities === void 0) {
      identities = [];
    }

    this.userType = userType;
    this.data = data;
    this.identities = identities;
  }

  StitchUserProfileImpl.empty = function () {
    return new StitchUserProfileImpl();
  };

  Object.defineProperty(StitchUserProfileImpl.prototype, "name", {
    get: function get() {
      return this.data[NAME];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(StitchUserProfileImpl.prototype, "email", {
    get: function get() {
      return this.data[EMAIL];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(StitchUserProfileImpl.prototype, "pictureUrl", {
    get: function get() {
      return this.data[PICTURE_URL];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(StitchUserProfileImpl.prototype, "firstName", {
    get: function get() {
      return this.data[FIRST_NAME];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(StitchUserProfileImpl.prototype, "lastName", {
    get: function get() {
      return this.data[LAST_NAME];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(StitchUserProfileImpl.prototype, "gender", {
    get: function get() {
      return this.data[GENDER];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(StitchUserProfileImpl.prototype, "birthday", {
    get: function get() {
      return this.data[BIRTHDAY];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(StitchUserProfileImpl.prototype, "minAge", {
    get: function get() {
      var age = this.data[MIN_AGE];

      if (age === undefined) {
        return undefined;
      }

      return age;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(StitchUserProfileImpl.prototype, "maxAge", {
    get: function get() {
      var age = this.data[MAX_AGE];

      if (age === undefined) {
        return undefined;
      }

      return age;
    },
    enumerable: true,
    configurable: true
  });
  return StitchUserProfileImpl;
}();

export default StitchUserProfileImpl;